module.exports = __webpack_public_path__ + "static/media/400065_02.7d17b23e.png";